// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vec-multi-option-group__MultiOption-module--dN5UV.ant-checkbox-group {
    display: flex !important;
    flex-direction: column !important;
    gap: var(--space-sm) !important;
    width: 100%;
}

.vec-multi-option-group-fit__MultiOption-module--IOlRn[data-scrolls].ant-checkbox-group {
    overflow-x: auto;
    padding: 3px;
    margin: -3px;
    width: calc(100% + 6px);
}

.vec-multi-option-group-fit__MultiOption-module--IOlRn[data-scrolls] > .ant-checkbox-wrapper {
    width: calc(100% + var(--vec-fit-extra)) !important;
    flex-shrink: 0;
}

.vec-multi-option__MultiOption-module--DrKQ6.ant-checkbox-wrapper {
    --vec-option-pad-left: var(--space-md);
    display: flex !important;
    align-items: center;
    width: 100%;
    margin: 0 !important;
    padding: var(--space-sm) var(--space-md) var(--space-sm) var(--vec-option-pad-left) !important;
    border: 2px solid transparent;
    border-radius: var(--radius-md) !important;
    background: var(--color-surface-raised);
    color: var(--color-text-primary);
    transition: color 0.2s, background-color 0.2s, border-color 0.2s, box-shadow 0.2s;
}

.vec-multi-option__MultiOption-module--DrKQ6 .ant-checkbox {
    position: absolute;
    inset: 0;
    opacity: 0;
    top: 0;
}

.vec-multi-option__MultiOption-module--DrKQ6 .ant-checkbox-input {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    margin: 0;
    cursor: pointer;
}

.vec-multi-option__MultiOption-module--DrKQ6 .ant-checkbox-inner {
    display: none;
}

.vec-multi-option__MultiOption-module--DrKQ6:has(:focus-visible) {
    outline: 2px solid var(--color-focus-outline);
    outline-offset: 2px;
}

.vec-multi-option__MultiOption-module--DrKQ6 .ant-checkbox-label {
    display: flex;
    align-items: center;
    gap: var(--space-sm);
    flex: 1;
    min-width: 0;
    padding: 0;
    color: var(--color-text-primary) !important;
}

.vec-multi-option__MultiOption-module--DrKQ6.ant-checkbox-wrapper-checked {
    background: var(--color-primary-100);
    border-color: var(--color-surface-brand);
}

.vec-multi-option-lead__MultiOption-module--g4lMl {
    display: flex;
    align-items: center;
    flex-shrink: 0;
}

[data-scrolls] .vec-multi-option__MultiOption-module--DrKQ6 .ant-checkbox-label {
    gap: 0;
    background: inherit;
}

[data-scrolls] .vec-multi-option-lead__MultiOption-module--g4lMl {
    position: sticky;
    left: 0;
    z-index: 1;
    align-self: stretch;
    margin-left: calc(-1 * var(--vec-option-pad-left));
    padding-inline: var(--vec-option-pad-left) var(--space-sm);
    background: inherit;
}

.vec-multi-option-badge__MultiOption-module--I2DAu {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 32px;
    height: 32px;
    border-radius: var(--radius-sm);
    background: var(--color-surface-base);
    color: var(--color-text-primary);
    font-weight: 600;
    transition: color 0.2s, background-color 0.2s;
}

.vec-multi-option__MultiOption-module--DrKQ6.ant-checkbox-wrapper-checked .vec-multi-option-badge__MultiOption-module--I2DAu {
    background: var(--color-surface-brand);
    color: var(--color-text-on-brand);
}

.vec-multi-option-pip__MultiOption-module--trPWj {
    position: absolute;
    opacity: 0;
    transform: scale(0);
    transition: opacity 0.2s, transform 0.2s cubic-bezier(0.34, 1.56, 0.64, 1);
    top: -6px;
    right: -6px;
    box-sizing: content-box;
    border: 2px solid var(--color-surface-base);
    border-radius: 50%;
    background: var(--color-surface-brand);
    color: var(--color-text-on-brand);
}

.vec-multi-option__MultiOption-module--DrKQ6.ant-checkbox-wrapper-checked .vec-multi-option-pip__MultiOption-module--trPWj {
    opacity: 1;
    transform: scale(1);
}

@media (prefers-reduced-motion: reduce) {
    .vec-multi-option__MultiOption-module--DrKQ6.ant-checkbox-wrapper,
    .vec-multi-option-badge__MultiOption-module--I2DAu,
    .vec-multi-option-pip__MultiOption-module--trPWj {
        transition: none;
    }
}

.vec-multi-option__MultiOption-module--DrKQ6.vec-multi-option-correct__MultiOption-module--FuxM0 {
    background: var(--color-feedback-success-bg);
    border-color: transparent;
}

.vec-multi-option__MultiOption-module--DrKQ6.vec-multi-option-correct__MultiOption-module--FuxM0 .vec-multi-option-badge__MultiOption-module--I2DAu {
    background: var(--color-feedback-success-text);
    color: var(--color-text-on-brand);
}

.vec-multi-option__MultiOption-module--DrKQ6.vec-multi-option-incorrect__MultiOption-module--OleLY {
    background: var(--color-feedback-error-bg);
    border-color: transparent;
}

.vec-multi-option__MultiOption-module--DrKQ6.vec-multi-option-incorrect__MultiOption-module--OleLY .vec-multi-option-badge__MultiOption-module--I2DAu {
    background: var(--color-feedback-error-text);
    color: var(--color-text-on-brand);
}

.vec-multi-option-content__MultiOption-module--qAO5r {
    flex: 1;
    min-width: 0;
    font-size: calc(var(--vec-option-font-size, 18px) * var(--eq-scale, 1));
}

/* below tablet: BREAKPOINTS.tablet (768) */
@media (max-width: 767px) {
    .vec-multi-option__MultiOption-module--DrKQ6.ant-checkbox-wrapper {
        --vec-option-pad-left: var(--space-sm);
    }

    .vec-multi-option-badge__MultiOption-module--I2DAu {
        width: 24px;
        height: 24px;
        font-size: 14px;
    }

    .vec-multi-option-content__MultiOption-module--qAO5r {
        --vec-option-font-size: 16px;
    }
}
`, "",{"version":3,"sources":["webpack://./vector/src/Option/MultiOption.module.css"],"names":[],"mappings":"AAAA;IACI,wBAAwB;IACxB,iCAAiC;IACjC,+BAA+B;IAC/B,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,uBAAuB;AAC3B;;AAEA;IACI,mDAAmD;IACnD,cAAc;AAClB;;AAEA;IACI,sCAAsC;IACtC,wBAAwB;IACxB,mBAAmB;IACnB,WAAW;IACX,oBAAoB;IACpB,8FAA8F;IAC9F,6BAA6B;IAC7B,0CAA0C;IAC1C,uCAAuC;IACvC,gCAAgC;IAChC,iFAAiF;AACrF;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,MAAM;AACV;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,6CAA6C;IAC7C,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,oBAAoB;IACpB,OAAO;IACP,YAAY;IACZ,UAAU;IACV,2CAA2C;AAC/C;;AAEA;IACI,oCAAoC;IACpC,wCAAwC;AAC5C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,MAAM;IACN,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,OAAO;IACP,UAAU;IACV,mBAAmB;IACnB,kDAAkD;IAClD,0DAA0D;IAC1D,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,WAAW;IACX,YAAY;IACZ,+BAA+B;IAC/B,qCAAqC;IACrC,gCAAgC;IAChC,gBAAgB;IAChB,6CAA6C;AACjD;;AAEA;IACI,sCAAsC;IACtC,iCAAiC;AACrC;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,mBAAmB;IACnB,0EAA0E;IAC1E,SAAS;IACT,WAAW;IACX,uBAAuB;IACvB,2CAA2C;IAC3C,kBAAkB;IAClB,sCAAsC;IACtC,iCAAiC;AACrC;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI;;;QAGI,gBAAgB;IACpB;AACJ;;AAEA;IACI,4CAA4C;IAC5C,yBAAyB;AAC7B;;AAEA;IACI,8CAA8C;IAC9C,iCAAiC;AACrC;;AAEA;IACI,0CAA0C;IAC1C,yBAAyB;AAC7B;;AAEA;IACI,4CAA4C;IAC5C,iCAAiC;AACrC;;AAEA;IACI,OAAO;IACP,YAAY;IACZ,uEAAuE;AAC3E;;AAEA,2CAA2C;AAC3C;IACI;QACI,sCAAsC;IAC1C;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,4BAA4B;IAChC;AACJ","sourcesContent":[".vec-multi-option-group:global(.ant-checkbox-group) {\n    display: flex !important;\n    flex-direction: column !important;\n    gap: var(--space-sm) !important;\n    width: 100%;\n}\n\n.vec-multi-option-group-fit[data-scrolls]:global(.ant-checkbox-group) {\n    overflow-x: auto;\n    padding: 3px;\n    margin: -3px;\n    width: calc(100% + 6px);\n}\n\n.vec-multi-option-group-fit[data-scrolls] > :global(.ant-checkbox-wrapper) {\n    width: calc(100% + var(--vec-fit-extra)) !important;\n    flex-shrink: 0;\n}\n\n.vec-multi-option:global(.ant-checkbox-wrapper) {\n    --vec-option-pad-left: var(--space-md);\n    display: flex !important;\n    align-items: center;\n    width: 100%;\n    margin: 0 !important;\n    padding: var(--space-sm) var(--space-md) var(--space-sm) var(--vec-option-pad-left) !important;\n    border: 2px solid transparent;\n    border-radius: var(--radius-md) !important;\n    background: var(--color-surface-raised);\n    color: var(--color-text-primary);\n    transition: color 0.2s, background-color 0.2s, border-color 0.2s, box-shadow 0.2s;\n}\n\n.vec-multi-option :global(.ant-checkbox) {\n    position: absolute;\n    inset: 0;\n    opacity: 0;\n    top: 0;\n}\n\n.vec-multi-option :global(.ant-checkbox-input) {\n    position: absolute;\n    inset: 0;\n    width: 100%;\n    height: 100%;\n    margin: 0;\n    cursor: pointer;\n}\n\n.vec-multi-option :global(.ant-checkbox-inner) {\n    display: none;\n}\n\n.vec-multi-option:has(:focus-visible) {\n    outline: 2px solid var(--color-focus-outline);\n    outline-offset: 2px;\n}\n\n.vec-multi-option :global(.ant-checkbox-label) {\n    display: flex;\n    align-items: center;\n    gap: var(--space-sm);\n    flex: 1;\n    min-width: 0;\n    padding: 0;\n    color: var(--color-text-primary) !important;\n}\n\n.vec-multi-option:global(.ant-checkbox-wrapper-checked) {\n    background: var(--color-primary-100);\n    border-color: var(--color-surface-brand);\n}\n\n.vec-multi-option-lead {\n    display: flex;\n    align-items: center;\n    flex-shrink: 0;\n}\n\n[data-scrolls] .vec-multi-option :global(.ant-checkbox-label) {\n    gap: 0;\n    background: inherit;\n}\n\n[data-scrolls] .vec-multi-option-lead {\n    position: sticky;\n    left: 0;\n    z-index: 1;\n    align-self: stretch;\n    margin-left: calc(-1 * var(--vec-option-pad-left));\n    padding-inline: var(--vec-option-pad-left) var(--space-sm);\n    background: inherit;\n}\n\n.vec-multi-option-badge {\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n    width: 32px;\n    height: 32px;\n    border-radius: var(--radius-sm);\n    background: var(--color-surface-base);\n    color: var(--color-text-primary);\n    font-weight: 600;\n    transition: color 0.2s, background-color 0.2s;\n}\n\n.vec-multi-option:global(.ant-checkbox-wrapper-checked) .vec-multi-option-badge {\n    background: var(--color-surface-brand);\n    color: var(--color-text-on-brand);\n}\n\n.vec-multi-option-pip {\n    position: absolute;\n    opacity: 0;\n    transform: scale(0);\n    transition: opacity 0.2s, transform 0.2s cubic-bezier(0.34, 1.56, 0.64, 1);\n    top: -6px;\n    right: -6px;\n    box-sizing: content-box;\n    border: 2px solid var(--color-surface-base);\n    border-radius: 50%;\n    background: var(--color-surface-brand);\n    color: var(--color-text-on-brand);\n}\n\n.vec-multi-option:global(.ant-checkbox-wrapper-checked) .vec-multi-option-pip {\n    opacity: 1;\n    transform: scale(1);\n}\n\n@media (prefers-reduced-motion: reduce) {\n    .vec-multi-option:global(.ant-checkbox-wrapper),\n    .vec-multi-option-badge,\n    .vec-multi-option-pip {\n        transition: none;\n    }\n}\n\n.vec-multi-option.vec-multi-option-correct {\n    background: var(--color-feedback-success-bg);\n    border-color: transparent;\n}\n\n.vec-multi-option.vec-multi-option-correct .vec-multi-option-badge {\n    background: var(--color-feedback-success-text);\n    color: var(--color-text-on-brand);\n}\n\n.vec-multi-option.vec-multi-option-incorrect {\n    background: var(--color-feedback-error-bg);\n    border-color: transparent;\n}\n\n.vec-multi-option.vec-multi-option-incorrect .vec-multi-option-badge {\n    background: var(--color-feedback-error-text);\n    color: var(--color-text-on-brand);\n}\n\n.vec-multi-option-content {\n    flex: 1;\n    min-width: 0;\n    font-size: calc(var(--vec-option-font-size, 18px) * var(--eq-scale, 1));\n}\n\n/* below tablet: BREAKPOINTS.tablet (768) */\n@media (max-width: 767px) {\n    .vec-multi-option:global(.ant-checkbox-wrapper) {\n        --vec-option-pad-left: var(--space-sm);\n    }\n\n    .vec-multi-option-badge {\n        width: 24px;\n        height: 24px;\n        font-size: 14px;\n    }\n\n    .vec-multi-option-content {\n        --vec-option-font-size: 16px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"vecMultiOptionGroup": `vec-multi-option-group__MultiOption-module--dN5UV`,
	"vecMultiOptionGroupFit": `vec-multi-option-group-fit__MultiOption-module--IOlRn`,
	"vecMultiOption": `vec-multi-option__MultiOption-module--DrKQ6`,
	"vecMultiOptionLead": `vec-multi-option-lead__MultiOption-module--g4lMl`,
	"vecMultiOptionBadge": `vec-multi-option-badge__MultiOption-module--I2DAu`,
	"vecMultiOptionPip": `vec-multi-option-pip__MultiOption-module--trPWj`,
	"vecMultiOptionCorrect": `vec-multi-option-correct__MultiOption-module--FuxM0`,
	"vecMultiOptionIncorrect": `vec-multi-option-incorrect__MultiOption-module--OleLY`,
	"vecMultiOptionContent": `vec-multi-option-content__MultiOption-module--qAO5r`
};
export default ___CSS_LOADER_EXPORT___;
